import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "image-extractor",
  title: "Image Extractor",
  pageHeading: "Image Extractor from URL",
  description:
    "Extract every discoverable image from a webpage URL, filter the results, copy source URLs, and download individual files or a ZIP.",
  seoTitle: "Image Extractor from URL - Download Website Images",
  seoDescription:
    "Extract images from any public webpage URL. Find HTML, lazy-loaded, srcset, CSS and social images, then filter, copy or download them free.",
  featureList: [
    "Extract images from a webpage URL",
    "Find srcset, lazy-loaded, CSS and social images",
    "Filter images by type and minimum width",
    "Copy image URLs or export them as a text file",
    "Download selected images as a ZIP",
  ],
  category: "Images",
} satisfies ToolMeta;
